import { render } from "./CreateRequest2.vue?vue&type=template&id=0c18f888"
import script from "./CreateRequest2.vue?vue&type=script&lang=js"
export * from "./CreateRequest2.vue?vue&type=script&lang=js"

import "./CreateRequest2.vue?vue&type=style&index=0&id=0c18f888&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__